var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 58,
    viewBox: "0 0 16 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29289 56.7874C7.68342 57.1779 8.31658 57.1779 8.70711 56.7874L15.0711 50.4234C15.4616 50.0329 15.4616 49.3998 15.0711 49.0092C14.6805 48.6187 14.0474 48.6187 13.6569 49.0092L8 54.6661L2.34315 49.0092C1.95262 48.6187 1.31946 48.6187 0.928932 49.0092C0.538408 49.3998 0.538408 50.0329 0.928932 50.4234L7.29289 56.7874ZM7 0L7 56.0803H9L9 0L7 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.4a489da586feefac5b687a9615ab04cc.svg";
export { ForwardRef as ReactComponent };